import { render, staticRenderFns } from "./FloatPts.vue?vue&type=template&id=a10b0f28&scoped=true"
import script from "./FloatPts.vue?vue&type=script&lang=js"
export * from "./FloatPts.vue?vue&type=script&lang=js"
import style0 from "./FloatPts.vue?vue&type=style&index=0&id=a10b0f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10b0f28",
  null
  
)

export default component.exports